// import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// /* ─────────────────────────────────────────
//    Invoice Number Generator
//    Format : INV/YYYY-YY/NNN
//    e.g.   : INV/2026-27/001
//    ───────────────────────────────────────── */
// const getFinancialYear = (dateStr) => {
//   const d = new Date(dateStr || Date.now());
//   const month = d.getMonth(); // 0-indexed; April = 3
//   const year  = d.getFullYear();
//   const startYear = month >= 3 ? year : year - 1;   // FY starts April
//   const endYear   = (startYear + 1).toString().slice(-2);
//   return `${startYear}-${endYear}`;
// };

// /**
//  * Generates invoice number from order.
//  * Priority:
//  *  1. order.invoiceNo if already in INV/... format → use as-is
//  *  2. order.orderNo   → zero-pad to 3 digits
//  *  3. Fallback sequential from _id
//  */
// const buildInvoiceNo = (order) => {
//   if (order.invoiceNo && /^INV\/\d{4}-\d{2}\/\d+$/.test(order.invoiceNo)) {
//     return order.invoiceNo; // already formatted
//   }
//   const fy  = getFinancialYear(order.createdAt);
//   const seq = order.orderNo
//     ? String(order.orderNo).padStart(3, "0")
//     : (order._id ? order._id.slice(-4).toUpperCase() : "001");
//   return `INV/${fy}/${seq}`;
// };

// /* ─────────────────────────────────────────
//    Formatters
//    ───────────────────────────────────────── */
// const fD = (d) =>
//   new Date(d).toLocaleDateString("en-IN", {
//     day: "2-digit", month: "short", year: "numeric",
//   });

// const fN = (n, d = 2) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: d,
//     maximumFractionDigits: d,
//   });

// const fC = (n, d = 2) => "₹" + fN(n, d);

// /* ─────────────────────────────────────────
//    Packing sort helpers
//    ───────────────────────────────────────── */
// const getPackingKey = (packing) => {
//   const str = (packing || "").toString().trim();
//   if (str === "—" || str === "") return "\uffff";
//   const cleaned = str.replace(/^(\d+\s+)+/, "").trim();
//   return cleaned.toLowerCase();
// };

// const packingSort = (a, b) => {
//   const kA = getPackingKey(a.packing);
//   const kB = getPackingKey(b.packing);
//   return kA.localeCompare(kB, "en", { sensitivity: "base" });
// };

// /* ─────────────────────────────────────────
//    Full Address builder
//    Handles nested or flat address objects
//    ───────────────────────────────────────── */
// const buildFullAddress = (order) => {
//   const addr = order.customer?.address || order.address || order.shippingAddress || {};

//   const parts = [
//     addr.houseNo    || addr.house     || addr.flatNo   || addr.flat,
//     addr.building   || addr.apartment || addr.society,
//     addr.street     || addr.line1     || addr.addressLine1,
//     addr.landmark   || addr.line2     || addr.addressLine2,
//     addr.locality   || addr.area      || addr.colony,
//     addr.city       || addr.district,
//     addr.state,
//     addr.pincode    || addr.zip       || addr.postalCode,
//   ].filter(Boolean);

//   return parts.length ? parts.join(", ") : (order.customer?.fullAddress || "—");
// };

// /* ═══════════════════════════════════════════
//    InvoicePage Component
//    ═══════════════════════════════════════════ */
// export default function InvoicePage() {
//   const navigate  = useNavigate();
//   const { state } = useLocation();

//   /* Support both single order and array of orders.
//      When array is passed, sort descending (latest first). */
//   const rawOrder  = state?.order;
//   const rawOrders = state?.orders;

//   // If multiple orders supplied, sort descending by createdAt
//   const orderList = rawOrders
//     ? [...rawOrders].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//     : rawOrder
//     ? [rawOrder]
//     : [];

//   // Active order = first in sorted list (or from direct state)
//   const order = orderList[0] ?? null;

//   /* ── No order guard ── */
//   if (!order) {
//     return (
//       <div style={{
//         minHeight: "100vh", display: "flex",
//         justifyContent: "center", alignItems: "center", background: "#f1f5f9",
//       }}>
//         <div style={{
//           background: "#fff", border: "0.5px solid #e2e8f0",
//           borderRadius: 12, padding: "40px 48px", textAlign: "center",
//         }}>
//           <h2 style={{ fontSize: 18, fontWeight: 500, color: "#0f172a", marginBottom: 8 }}>
//             No Order Found
//           </h2>
//           <p style={{ fontSize: 13, color: "#64748b" }}>
//             Please navigate from your orders page.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   /* ── Derived invoice number ── */
//   const invoiceNo = buildInvoiceNo(order);

//   /* ── Item calculations ── */
//   const calcItems = (order.items || []).map((it) => {
//     const lineTotal = Number(it.price    || 0);
//     const unitPrice = Number(it.unitPrice || it.rate || 0);
//     const gstRate   = Number(it.gstRate  || 0);
//     const cessRate  = Number(it.cess     || 0);
//     const mrp       = Number(it.mrp      || unitPrice);
//     const quantity  = Number(it.quantity || 1);

//     const divisor  = 1 + gstRate / 100 + cessRate / 100;
//     const taxable  = lineTotal / divisor;
//     const gstAmt   = taxable * (gstRate / 100);
//     const cessAmt  = taxable * (cessRate / 100);
//     const totalGst = gstAmt + cessAmt;

//     const rawPacking = it.packagingText || it.packing || "—";

//     return {
//       ...it,
//       packing:        rawPacking,
//       packingDisplay: rawPacking,
//       packagingText:  rawPacking,
//       rate:     unitPrice,
//       mrp,
//       gstRate,
//       cessRate,
//       taxable,
//       gst:      gstAmt,
//       cess:     cessAmt,
//       sgst:     gstAmt / 2,
//       cgst:     gstAmt / 2,
//       totalGst,
//       total:    lineTotal,
//     };
//   }).sort(packingSort);

//   /* ── HSN Summary ── */
//   const hsnMap = {};
//   calcItems.forEach((it) => {
//     const key = it.hsn || "N/A";
//     if (!hsnMap[key]) hsnMap[key] = { taxable: 0, sgst: 0, cgst: 0, cess: 0, total: 0 };
//     hsnMap[key].taxable += it.taxable;
//     hsnMap[key].sgst    += it.sgst;
//     hsnMap[key].cgst    += it.cgst;
//     hsnMap[key].cess    += it.cess;
//     hsnMap[key].total   += it.total;
//   });

//   const grandTotal   = calcItems.reduce((s, i) => s + i.total,    0);
//   const totalGST     = calcItems.reduce((s, i) => s + i.totalGst, 0);
//   const totalCess    = calcItems.reduce((s, i) => s + i.cess,     0);

//   /* ── Charges ── */
//   const deliveryCharge = Number(order.deliveryCharge || 0);
//   const handlingCharge = Number(order.handlingCharge || 0);
//   const couponDiscount = Number(order.couponDiscount || 0);
//   const effectiveTotal = order.finalPrice ?? (grandTotal + deliveryCharge + handlingCharge - couponDiscount);

//   /* ── Status color ── */
//   const statusMap = {
//     pending:   { bg: "#fff7ed", color: "#c2410c", dot: "#fb923c" },
//     confirmed: { bg: "#f0fdf4", color: "#15803d", dot: "#4ade80" },
//     placed:    { bg: "#fff7ed", color: "#c2410c", dot: "#fb923c" },
//     delivered: { bg: "#eff6ff", color: "#1d4ed8", dot: "#60a5fa" },
//     cancelled: { bg: "#fff1f2", color: "#be123c", dot: "#fb7185" },
//   };
//   const sc = statusMap[order.status?.toLowerCase()] || statusMap.pending;

//   /* ── Full address ── */
//   const addrFull = buildFullAddress(order);

//   /* ── Shared styles ── */
//   const lbl      = { fontSize: 10, color: "#94a3b8", marginBottom: 2 };
//   const val      = { fontSize: 12, fontWeight: 500, color: "#0f172a", lineHeight: 1.5 };
//   const divider  = { border: "none", borderTop: "0.5px solid #e2e8f0", margin: "14px 0" };
//   const secLabel = {
//     fontSize: 9, fontWeight: 600, letterSpacing: "1.5px",
//     textTransform: "uppercase", color: "#64748b", marginBottom: 8,
//   };
//   const th = {
//     padding: "6px 5px",
//     fontSize: 9, fontWeight: 600, letterSpacing: "0.8px",
//     textTransform: "uppercase", color: "#64748b",
//     borderBottom: "0.5px solid #e2e8f0",
//     background: "#f8fafc",
//     WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
//     whiteSpace: "nowrap",
//   };
//   const td  = {
//     padding: "7px 5px", fontSize: 11, color: "#0f172a",
//     borderBottom: "0.5px solid #f1f5f9",
//     overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
//   };
//   const tdR = { ...td, textAlign: "right", fontFamily: "monospace", fontSize: 10.5 };
//   const thR = { ...th, textAlign: "right" };

//   /* ── TotalRow helper ── */
//   const TotalRow = ({ label, value, highlight, green, red, mono = true, note }) => (
//     <div style={{
//       display: "flex", justifyContent: "space-between", alignItems: "center",
//       padding: highlight ? "10px 0 0" : "4px 0",
//       marginTop: highlight ? 6 : 0,
//       borderTop: highlight ? "1.5px solid #0f172a" : "none",
//       fontSize: highlight ? 14 : 12,
//       fontWeight: highlight ? 600 : 400,
//       color: highlight ? "#0f172a" : "#64748b",
//     }}>
//       <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
//         {label}
//         {note && (
//           <span style={{ fontSize: 9, background: "#f0fdf4", color: "#16a34a", padding: "1px 6px", borderRadius: 4, fontFamily: "monospace" }}>
//             {note}
//           </span>
//         )}
//       </span>
//       <span style={{
//         fontFamily: mono ? "monospace" : "inherit",
//         fontSize: highlight ? 13 : 11.5,
//         color: highlight ? "#b45309" : green ? "#16a34a" : red ? "#e11d48" : "#0f172a",
//         fontWeight: highlight ? 600 : green || red ? 500 : 400,
//       }}>
//         {value}
//       </span>
//     </div>
//   );

//   return (
//     <>
//       <style>{`
//         * { box-sizing: border-box; margin: 0; padding: 0; }
//         body { background: #f1f5f9; }

//         @page { size: A4; margin: 10mm 8mm; }

//         @media print {
//           .no-print { display: none !important; }
//           html, body { background: #fff !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
//           .invoice-wrapper { padding: 0 !important; background: #fff !important; display: block !important; width: 100% !important; }
//           .invoice-card { width: 100% !important; max-width: 100% !important; border: none !important; border-radius: 0 !important; box-shadow: none !important; overflow: visible !important; }
//           * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
//           .item-table-wrap { overflow: visible !important; width: 100% !important; }
//           .item-table-wrap table { min-width: unset !important; width: 100% !important; table-layout: auto !important; font-size: 7.5pt !important; }
//           .item-table-wrap table th, .item-table-wrap table td { font-size: 7.5pt !important; padding: 4px 3px !important; white-space: normal !important; word-break: break-word !important; }
//           .hsn-table-wrap { overflow: visible !important; width: 100% !important; }
//           .hsn-table-wrap table { min-width: unset !important; width: 100% !important; table-layout: auto !important; font-size: 7.5pt !important; }
//           .hsn-table-wrap table th, .hsn-table-wrap table td { font-size: 7.5pt !important; padding: 4px 3px !important; }
//           .invoice-body { padding: 12px 16px !important; }
//           table { page-break-inside: avoid; }
//           tr    { page-break-inside: avoid; }
//         }
//       `}</style>

//       {/* Back Button */}
//       <div className="no-print" style={{ display: "flex", justifyContent: "center", marginBottom: 14, paddingTop: 16 }}>
//         <div style={{ width: "100%", maxWidth: 900, display: "flex", justifyContent: "flex-start" }}>
//           <button
//             onClick={() => navigate(-1)}
//             style={{
//               display: "flex", alignItems: "center", gap: 6, padding: "8px 16px",
//               border: "0.5px solid #cbd5e1", borderRadius: 8, background: "#fff",
//               fontSize: 12, fontWeight: 500, color: "#0f172a", cursor: "pointer",
//               boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//             }}
//             onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
//             onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
//           >
//             ← Back
//           </button>
//         </div>
//       </div>

//       <div
//         className="invoice-wrapper"
//         style={{
//           fontFamily: "'Inter', 'Segoe UI', sans-serif",
//           padding: "0 12px 24px", minHeight: "100vh",
//           display: "flex", justifyContent: "center", alignItems: "flex-start",
//           background: "#f1f5f9",
//         }}
//       >
//         <div
//           className="invoice-card"
//           style={{
//             width: "100%", maxWidth: 900,
//             background: "#fff", border: "0.5px solid #e2e8f0",
//             borderRadius: 12, overflow: "hidden",
//           }}
//         >

//           {/* ── Header ── */}
//           <div style={{
//             background: "#0f172a", padding: "20px 28px",
//             display: "flex", justifyContent: "space-between",
//             alignItems: "flex-start", flexWrap: "wrap", gap: 12,
//             WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
//           }}>
//             <div>
//               <div style={{ fontSize: 22, fontWeight: 500, color: "#f8fafc", letterSpacing: 2 }}>INVOICE</div>
//               {/* ✅ Updated invoice number in INV/YYYY-YY/NNN format */}
//               <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3, fontFamily: "monospace" }}>
//                 {invoiceNo} · {fD(order.createdAt)}
//               </div>
//             </div>
//             <div style={{ textAlign: "right" }}>
//               <div style={{ fontSize: 14, fontWeight: 500, color: "#f8fafc" }}>{order.vendor?.name}</div>
//               <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3, lineHeight: 1.6 }}>
//                 {order.vendor?.email}<br />{order.vendor?.phone}
//               </div>
//             </div>
//           </div>

//           {/* Amber stripe */}
//           <div style={{ height: 3, background: "#f59e0b", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} />

//           {/* ── Body ── */}
//           <div className="invoice-body" style={{ padding: "20px 28px" }}>

//             {/* Vendor Details */}
//             <div style={secLabel}>Vendor Details</div>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 10 }}>
//               <div><div style={lbl}>Company</div><div style={val}>FoodHelper Indore</div></div>
//               <div><div style={lbl}>GSTIN</div><div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{order.vendor?.gstin}</div></div>
//               <div><div style={lbl}>Contact</div><div style={val}>{order.vendor?.phone}</div></div>
//               <div><div style={lbl}>Address</div><div style={val}>Indore</div></div>
//             </div>

//             <hr style={divider} />

//             {/* Customer Details */}
//             <div style={secLabel}>Customer Details</div>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 10 }}>
//               <div><div style={lbl}>Name</div><div style={val}>{order.customer?.name || order.userName || "—"}</div></div>
//               <div><div style={lbl}>GSTIN</div><div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{order.customer?.gstin || "—"}</div></div>
//               <div><div style={lbl}>Phone</div><div style={val}>{order.customer?.phone || order.address?.phone || order.shippingAddress?.phone || "—"}</div></div>
//               {/* ✅ Full address — all fields joined */}
//               <div>
//                 <div style={lbl}>Shipping Address</div>
//                 <div style={{ ...val, whiteSpace: "normal", lineHeight: 1.6, fontSize: 11 }}>
//                   {addrFull}
//                 </div>
//               </div>
//             </div>

//             <hr style={divider} />

//             {/* ── Order & Invoice Details ── */}
//             <div style={secLabel}>Order & Invoice Details</div>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, marginBottom: 14 }}>

//               {/* Sr. No. */}
//               <div>
//                 <div style={lbl}>Sr. No.</div>
//                 <div style={{
//                   ...val,
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   width: 32, height: 32,
//                   borderRadius: "50%",
//                   background: "#0f172a",
//                   color: "#f8fafc",
//                   fontSize: 13,
//                   fontWeight: 700,
//                   fontFamily: "monospace",
//                   WebkitPrintColorAdjust: "exact",
//                   printColorAdjust: "exact",
//                 }}>
//                   {order.orderNo ?? "—"}
//                 </div>
//               </div>

//               <div>
//                 <div style={lbl}>Invoice No.</div>
//                 {/* ✅ Formatted invoice number shown here too */}
//                 <div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{invoiceNo}</div>
//               </div>
//               <div><div style={lbl}>Invoice Date</div><div style={val}>{fD(order.createdAt)}</div></div>
//               <div><div style={lbl}>Due Date</div><div style={val}>{order.dueDate ? fD(order.dueDate) : "—"}</div></div>
//               <div><div style={lbl}>Payment Mode</div><div style={val}>{order.paymentMode || "—"}</div></div>
//               <div>
//                 <div style={lbl}>Status</div>
//                 <div style={{
//                   display: "inline-flex", alignItems: "center", gap: 5,
//                   padding: "2px 9px", borderRadius: 999,
//                   background: sc.bg, color: sc.color, fontSize: 11, fontWeight: 500,
//                   WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
//                 }}>
//                   <span style={{ width: 6, height: 6, borderRadius: "50%", background: sc.dot, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} />
//                   {order.status?.charAt(0).toUpperCase() + order.status?.slice(1)}
//                 </div>
//               </div>
//             </div>

//             <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, marginBottom: 14 }}>
//               <div><div style={lbl}>Total Items</div><div style={val}>{order.items?.length || 0}</div></div>
//             </div>

//             <hr style={divider} />

//             {/* ── Item Table ── */}
//             <div style={secLabel}>Item Details</div>
//             <div className="item-table-wrap" style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", minWidth: 800, borderCollapse: "collapse", tableLayout: "fixed" }}>
//                 <colgroup>
//                   <col style={{ width: 24 }} />
//                   <col style={{ width: "16%" }} />
//                   <col style={{ width: "7%" }} />
//                   <col style={{ width: "7%" }} />
//                   <col style={{ width: "5%" }} />
//                   <col style={{ width: "5%" }} />
//                   <col style={{ width: "5%" }} />
//                   <col style={{ width: "9%" }} />
//                   <col style={{ width: "8%" }} />
//                   <col style={{ width: "9%" }} />
//                   <col style={{ width: "7%" }} />
//                   <col style={{ width: "7%" }} />
//                   <col style={{ width: "8%" }} />
//                 </colgroup>
//                 <thead>
//                   <tr>
//                     <th style={th}>#</th>
//                     <th style={th}>Item Name</th>
//                     <th style={thR}>MRP</th>
//                     <th style={th}>HSN</th>
//                     <th style={th}>GST%</th>
//                     <th style={thR}>Qty</th>
//                     <th style={th}>Unit</th>
//                     <th style={th}>Packing</th>
//                     <th style={thR}>Rate (Incl.)</th>
//                     <th style={thR}>Taxable</th>
//                     <th style={thR}>CGST</th>
//                     <th style={thR}>SGST</th>
//                     <th style={thR}>Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {calcItems.map((it, i) => (
//                     <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
//                       <td style={td}>{i + 1}</td>
//                       <td style={{ ...td, fontWeight: 500 }} title={it.name}>{it.name}</td>
//                       <td style={tdR}>{fN(it.mrp)}</td>
//                       <td style={{ ...td, fontFamily: "monospace", fontSize: 10.5 }}>{it.hsn || "N/A"}</td>
//                       <td style={td}>{it.gstRate}%</td>
//                       <td style={tdR}>{it.quantity}</td>
//                       <td style={td}>{it.unit || "pcs"}</td>
//                       <td style={{ ...td, fontSize: 10.5, color: "#64748b", whiteSpace: "normal", wordBreak: "break-word" }}>{it.packingDisplay}</td>
//                       <td style={tdR}>{fN(it.rate)}</td>
//                       <td style={tdR}>{fN(it.taxable, 3)}</td>
//                       <td style={tdR}>{fN(it.cgst, 3)}</td>
//                       <td style={tdR}>{fN(it.sgst, 3)}</td>
//                       <td style={{ ...tdR, fontWeight: 600 }}>{fN(it.total, 2)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <hr style={divider} />

//             {/* ── HSN GST Summary ── */}
//             <div style={secLabel}>Cumulative HSN-Wise GST Summary</div>
//             <div className="hsn-table-wrap" style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", minWidth: 580, borderCollapse: "collapse", tableLayout: "fixed" }}>
//                 <colgroup>
//                   <col style={{ width: "10%" }} />
//                   <col style={{ width: "18%" }} />
//                   <col style={{ width: "14%" }} />
//                   <col style={{ width: "14%" }} />
//                   <col style={{ width: "10%" }} />
//                   <col style={{ width: "16%" }} />
//                   <col />
//                 </colgroup>
//                 <thead>
//                   <tr>
//                     <th style={th}>HSN</th>
//                     <th style={thR}>Taxable Amt</th>
//                     <th style={thR}>SGST</th>
//                     <th style={thR}>CGST</th>
//                     <th style={thR}>CESS</th>
//                     <th style={thR}>Total Amt</th>
//                     <th style={th}>Remark</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Object.entries(hsnMap).map(([hsn, v]) => (
//                     <tr key={hsn}>
//                       <td style={{ ...td, fontFamily: "monospace", fontSize: 10.5 }}>{hsn}</td>
//                       <td style={tdR}>{fN(v.taxable, 2)}</td>
//                       <td style={tdR}>{fN(v.sgst, 3)}</td>
//                       <td style={tdR}>{fN(v.cgst, 3)}</td>
//                       <td style={tdR}>{fN(v.cess, 3)}</td>
//                       <td style={{ ...tdR, fontWeight: 600 }}>{fN(v.total, 2)}</td>
//                       <td style={{ ...td, fontSize: 10, color: "#94a3b8", fontStyle: "italic" }}>
//                         All HSN {hsn} cumulative
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* ── Totals ── */}
//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
//               <div style={{ minWidth: 290 }}>
//                 <TotalRow label="Items Subtotal" value={fC(grandTotal, 2)} />
//                 <TotalRow label="CGST" value={fC(totalGST / 2, 2)} />
//                 <TotalRow label="SGST" value={fC(totalGST / 2, 2)} />

//                 {totalCess > 0 && (
//                   <TotalRow label="CESS" value={fC(totalCess, 2)} />
//                 )}

//                 <TotalRow
//                   label="Total GST (Incl. in price)"
//                   value={fC(totalGST + totalCess, 2)}
//                 />

//                 {deliveryCharge > 0 ? (
//                   <TotalRow label="Delivery Charge" value={fC(deliveryCharge, 2)} />
//                 ) : (
//                   <TotalRow label="Delivery Charge" value="Free" green mono={false} />
//                 )}

//                 {handlingCharge > 0 ? (
//                   <TotalRow label="Handling Charge" value={fC(handlingCharge, 2)} />
//                 ) : (
//                   <TotalRow label="Handling Charge" value="Free" green mono={false} />
//                 )}

//                 {couponDiscount > 0 && (
//                   <TotalRow
//                     label="Coupon Discount"
//                     note={order.couponCode || undefined}
//                     value={`− ${fC(couponDiscount, 2)}`}
//                     green
//                   />
//                 )}

//                 <TotalRow label="Grand Total" value={fC(effectiveTotal, 2)} highlight />

//                 <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 6, textAlign: "right", fontStyle: "italic" }}>
//                   * Item prices are GST-inclusive · Delivery &amp; Handling added separately
//                 </div>
//               </div>
//             </div>

//           </div>

//           {/* ── Footer ── */}
//           <div style={{
//             padding: "12px 28px",
//             borderTop: "0.5px solid #e2e8f0",
//             display: "flex", justifyContent: "space-between", alignItems: "center",
//             background: "#f8fafc", flexWrap: "wrap", gap: 8,
//             WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
//           }}>
//             <span style={{ fontSize: 11, color: "#94a3b8" }}>
//               Thank you for your business · {order.vendor?.name} © {new Date().getFullYear()}
//             </span>
//             <button
//               className="no-print"
//               onClick={() => window.print()}
//               style={{
//                 padding: "6px 16px",
//                 border: "0.5px solid #cbd5e1",
//                 borderRadius: 8,
//                 background: "transparent",
//                 fontSize: 11, fontWeight: 500, color: "#0f172a", cursor: "pointer",
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
//               onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
//             >
//               Print Invoice
//             </button>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }


import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/* ─────────────────────────────────────────
   Formatters
   ───────────────────────────────────────── */
const fD = (d) =>
  new Date(d).toLocaleDateString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
  });

const fN = (n, d = 2) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });

const fC = (n, d = 2) => "₹" + fN(n, d);

/* ─────────────────────────────────────────
   Packing sort helpers
   ───────────────────────────────────────── */
const getPackingKey = (packing) => {
  const str = (packing || "").toString().trim();
  if (str === "—" || str === "") return "\uffff";
  const cleaned = str.replace(/^(\d+\s+)+/, "").trim();
  return cleaned.toLowerCase();
};

const packingSort = (a, b) => {
  const kA = getPackingKey(a.packing);
  const kB = getPackingKey(b.packing);
  return kA.localeCompare(kB, "en", { sensitivity: "base" });
};

/* ─────────────────────────────────────────
   Full Address builder
   ───────────────────────────────────────── */
const buildFullAddress = (order) => {
  const addr = order.customer?.address || order.address || order.shippingAddress || {};

  const parts = [
    addr.houseNo    || addr.house     || addr.flatNo   || addr.flat,
    addr.building   || addr.apartment || addr.society,
    addr.street     || addr.line1     || addr.addressLine1,
    addr.landmark   || addr.line2     || addr.addressLine2,
    addr.locality   || addr.area      || addr.colony,
    addr.city       || addr.district,
    addr.state,
    addr.pincode    || addr.zip       || addr.postalCode,
  ].filter(Boolean);

  return parts.length ? parts.join(", ") : (order.customer?.fullAddress || "—");
};

/* ═══════════════════════════════════════════
   InvoicePage Component
   ═══════════════════════════════════════════ */
export default function InvoicePage() {
  const navigate  = useNavigate();
  const { state } = useLocation();

  /* Support both single order and array of orders. */
  const rawOrder  = state?.order;
  const rawOrders = state?.orders;

  const orderList = rawOrders
    ? [...rawOrders].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    : rawOrder
    ? [rawOrder]
    : [];

  const order = orderList[0] ?? null;

  /* ── No order guard ── */
  if (!order) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex",
        justifyContent: "center", alignItems: "center", background: "#f1f5f9",
      }}>
        <div style={{
          background: "#fff", border: "0.5px solid #e2e8f0",
          borderRadius: 12, padding: "40px 48px", textAlign: "center",
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 500, color: "#0f172a", marginBottom: 8 }}>
            No Order Found
          </h2>
          <p style={{ fontSize: 13, color: "#64748b" }}>
            Please navigate from your orders page.
          </p>
        </div>
      </div>
    );
  }

  /* ── invoiceNo comes pre-built from AdminOrders ── */
  // It will be null/undefined if order is not confirmed/shipped/delivered
  const invoiceNo = order.invoiceNo || null;

  /* ── Item calculations ── */
  const calcItems = (order.items || []).map((it) => {
    const lineTotal = Number(it.price    || 0);
    const unitPrice = Number(it.unitPrice || it.rate || 0);
    const gstRate   = Number(it.gstRate  || 0);
    const cessRate  = Number(it.cess     || 0);
    const mrp       = Number(it.mrp      || unitPrice);
    const quantity  = Number(it.quantity || 1);

    const divisor  = 1 + gstRate / 100 + cessRate / 100;
    const taxable  = lineTotal / divisor;
    const gstAmt   = taxable * (gstRate / 100);
    const cessAmt  = taxable * (cessRate / 100);
    const totalGst = gstAmt + cessAmt;

    const rawPacking = it.packagingText || it.packing || "—";

    return {
      ...it,
      packing:        rawPacking,
      packingDisplay: rawPacking,
      packagingText:  rawPacking,
      rate:     unitPrice,
      mrp,
      gstRate,
      cessRate,
      taxable,
      gst:      gstAmt,
      cess:     cessAmt,
      sgst:     gstAmt / 2,
      cgst:     gstAmt / 2,
      totalGst,
      total:    lineTotal,
    };
  }).sort(packingSort);

  /* ── HSN Summary ── */
  const hsnMap = {};
  calcItems.forEach((it) => {
    const key = it.hsn || "N/A";
    if (!hsnMap[key]) hsnMap[key] = { taxable: 0, sgst: 0, cgst: 0, cess: 0, total: 0 };
    hsnMap[key].taxable += it.taxable;
    hsnMap[key].sgst    += it.sgst;
    hsnMap[key].cgst    += it.cgst;
    hsnMap[key].cess    += it.cess;
    hsnMap[key].total   += it.total;
  });

  const grandTotal   = calcItems.reduce((s, i) => s + i.total,    0);
  const totalGST     = calcItems.reduce((s, i) => s + i.totalGst, 0);
  const totalCess    = calcItems.reduce((s, i) => s + i.cess,     0);

  /* ── Charges ── */
  const deliveryCharge = Number(order.deliveryCharge || 0);
  const handlingCharge = Number(order.handlingCharge || 0);
  const couponDiscount = Number(order.couponDiscount || 0);
  const effectiveTotal = order.finalPrice ?? (grandTotal + deliveryCharge + handlingCharge - couponDiscount);

  /* ── Status color ── */
  const statusMap = {
    pending:   { bg: "#fff7ed", color: "#c2410c", dot: "#fb923c" },
    confirmed: { bg: "#f0fdf4", color: "#15803d", dot: "#4ade80" },
    placed:    { bg: "#fff7ed", color: "#c2410c", dot: "#fb923c" },
    delivered: { bg: "#eff6ff", color: "#1d4ed8", dot: "#60a5fa" },
    cancelled: { bg: "#fff1f2", color: "#be123c", dot: "#fb7185" },
  };
  const sc = statusMap[order.status?.toLowerCase()] || statusMap.pending;

  /* ── Full address ── */
  const addrFull = buildFullAddress(order);

  /* ── Shared styles ── */
  const lbl      = { fontSize: 10, color: "#94a3b8", marginBottom: 2 };
  const val      = { fontSize: 12, fontWeight: 500, color: "#0f172a", lineHeight: 1.5 };
  const divider  = { border: "none", borderTop: "0.5px solid #e2e8f0", margin: "14px 0" };
  const secLabel = {
    fontSize: 9, fontWeight: 600, letterSpacing: "1.5px",
    textTransform: "uppercase", color: "#64748b", marginBottom: 8,
  };
  const th = {
    padding: "6px 5px",
    fontSize: 9, fontWeight: 600, letterSpacing: "0.8px",
    textTransform: "uppercase", color: "#64748b",
    borderBottom: "0.5px solid #e2e8f0",
    background: "#f8fafc",
    WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
    whiteSpace: "nowrap",
  };
  const td  = {
    padding: "7px 5px", fontSize: 11, color: "#0f172a",
    borderBottom: "0.5px solid #f1f5f9",
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
  };
  const tdR = { ...td, textAlign: "right", fontFamily: "monospace", fontSize: 10.5 };
  const thR = { ...th, textAlign: "right" };

  /* ── TotalRow helper ── */
  const TotalRow = ({ label, value, highlight, green, red, mono = true, note }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: highlight ? "10px 0 0" : "4px 0",
      marginTop: highlight ? 6 : 0,
      borderTop: highlight ? "1.5px solid #0f172a" : "none",
      fontSize: highlight ? 14 : 12,
      fontWeight: highlight ? 600 : 400,
      color: highlight ? "#0f172a" : "#64748b",
    }}>
      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {label}
        {note && (
          <span style={{ fontSize: 9, background: "#f0fdf4", color: "#16a34a", padding: "1px 6px", borderRadius: 4, fontFamily: "monospace" }}>
            {note}
          </span>
        )}
      </span>
      <span style={{
        fontFamily: mono ? "monospace" : "inherit",
        fontSize: highlight ? 13 : 11.5,
        color: highlight ? "#b45309" : green ? "#16a34a" : red ? "#e11d48" : "#0f172a",
        fontWeight: highlight ? 600 : green || red ? 500 : 400,
      }}>
        {value}
      </span>
    </div>
  );

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #f1f5f9; }

        @page { size: A4; margin: 10mm 8mm; }

        @media print {
          .no-print { display: none !important; }
          html, body { background: #fff !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
          .invoice-wrapper { padding: 0 !important; background: #fff !important; display: block !important; width: 100% !important; }
          .invoice-card { width: 100% !important; max-width: 100% !important; border: none !important; border-radius: 0 !important; box-shadow: none !important; overflow: visible !important; }
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
          .item-table-wrap { overflow: visible !important; width: 100% !important; }
          .item-table-wrap table { min-width: unset !important; width: 100% !important; table-layout: auto !important; font-size: 7.5pt !important; }
          .item-table-wrap table th, .item-table-wrap table td { font-size: 7.5pt !important; padding: 4px 3px !important; white-space: normal !important; word-break: break-word !important; }
          .hsn-table-wrap { overflow: visible !important; width: 100% !important; }
          .hsn-table-wrap table { min-width: unset !important; width: 100% !important; table-layout: auto !important; font-size: 7.5pt !important; }
          .hsn-table-wrap table th, .hsn-table-wrap table td { font-size: 7.5pt !important; padding: 4px 3px !important; }
          .invoice-body { padding: 12px 16px !important; }
          table { page-break-inside: avoid; }
          tr    { page-break-inside: avoid; }
        }
      `}</style>

      {/* Back Button */}
      <div className="no-print" style={{ display: "flex", justifyContent: "center", marginBottom: 14, paddingTop: 16 }}>
        <div style={{ width: "100%", maxWidth: 900, display: "flex", justifyContent: "flex-start" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: "flex", alignItems: "center", gap: 6, padding: "8px 16px",
              border: "0.5px solid #cbd5e1", borderRadius: 8, background: "#fff",
              fontSize: 12, fontWeight: 500, color: "#0f172a", cursor: "pointer",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
          >
            ← Back
          </button>
        </div>
      </div>

      <div
        className="invoice-wrapper"
        style={{
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          padding: "0 12px 24px", minHeight: "100vh",
          display: "flex", justifyContent: "center", alignItems: "flex-start",
          background: "#f1f5f9",
        }}
      >
        <div
          className="invoice-card"
          style={{
            width: "100%", maxWidth: 900,
            background: "#fff", border: "0.5px solid #e2e8f0",
            borderRadius: 12, overflow: "hidden",
          }}
        >

          {/* ── Header ── */}
          <div style={{
            background: "#0f172a", padding: "20px 28px",
            display: "flex", justifyContent: "space-between",
            alignItems: "flex-start", flexWrap: "wrap", gap: 12,
            WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
          }}>
            <div>
              <div style={{ fontSize: 22, fontWeight: 500, color: "#f8fafc", letterSpacing: 2 }}>INVOICE</div>
              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3, fontFamily: "monospace" }}>
                {/* Show invoice number if available, else show pending message */}
                {invoiceNo
                  ? `${invoiceNo} · ${fD(order.createdAt)}`
                  : `Pending Confirmation · ${fD(order.createdAt)}`
                }
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: "#f8fafc" }}>{order.vendor?.name}</div>
              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 3, lineHeight: 1.6 }}>
                {order.vendor?.email}<br />{order.vendor?.phone}
              </div>
            </div>
          </div>

          {/* Amber stripe */}
          <div style={{ height: 3, background: "#f59e0b", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} />

          {/* ── Body ── */}
          <div className="invoice-body" style={{ padding: "20px 28px" }}>

            {/* ── Invoice Not Ready Banner (if order not confirmed) ── */}
            {!invoiceNo && (
              <div style={{
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                borderRadius: 8,
                padding: "10px 16px",
                marginBottom: 16,
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}>
                <span style={{ fontSize: 18 }}>⚠️</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#c2410c" }}>
                    Invoice Number Not Generated Yet
                  </div>
                  <div style={{ fontSize: 11, color: "#ea580c", marginTop: 2 }}>
                    Invoice number will be assigned once the order status is changed to <strong>Confirmed</strong>, <strong>Shipped</strong>, or <strong>Delivered</strong>.
                  </div>
                </div>
              </div>
            )}

            {/* Vendor Details */}
            <div style={secLabel}>Vendor Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 10 }}>
              <div><div style={lbl}>Company</div><div style={val}>FoodHelper Indore</div></div>
              <div><div style={lbl}>GSTIN</div><div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{order.vendor?.gstin}</div></div>
              <div><div style={lbl}>Contact</div><div style={val}>{order.vendor?.phone}</div></div>
              <div><div style={lbl}>Address</div><div style={val}>Indore</div></div>
            </div>

            <hr style={divider} />

            {/* Customer Details */}
            <div style={secLabel}>Customer Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 10 }}>
              <div><div style={lbl}>Name</div><div style={val}>{order.customer?.name || order.userName || "—"}</div></div>
              <div><div style={lbl}>GSTIN</div><div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{order.customer?.gstin || "—"}</div></div>
              <div><div style={lbl}>Phone</div><div style={val}>{order.customer?.phone || order.address?.phone || order.shippingAddress?.phone || "—"}</div></div>
              <div>
                <div style={lbl}>Shipping Address</div>
                <div style={{ ...val, whiteSpace: "normal", lineHeight: 1.6, fontSize: 11 }}>{addrFull}</div>
              </div>
            </div>

            <hr style={divider} />

            {/* ── Order & Invoice Details ── */}
            <div style={secLabel}>Order & Invoice Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, marginBottom: 14 }}>

              {/* Sr. No. */}
              <div>
                <div style={lbl}>Sr. No.</div>
                <div style={{
                  ...val,
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  width: 32, height: 32, borderRadius: "50%",
                  background: "#0f172a", color: "#f8fafc",
                  fontSize: 13, fontWeight: 700, fontFamily: "monospace",
                  WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
                }}>
                  {order.orderNo ?? "—"}
                </div>
              </div>

              <div>
                <div style={lbl}>Invoice No.</div>
                {invoiceNo ? (
                  <div style={{ ...val, fontFamily: "monospace", fontSize: 11 }}>{invoiceNo}</div>
                ) : (
                  <div style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    padding: "3px 8px", borderRadius: 6,
                    background: "#fff7ed", border: "0.5px solid #fed7aa",
                    fontSize: 10, color: "#c2410c", fontWeight: 600,
                  }}>
                    ⏳ Pending
                  </div>
                )}
              </div>

              <div><div style={lbl}>Invoice Date</div><div style={val}>{invoiceNo ? fD(order.createdAt) : "—"}</div></div>
              <div><div style={lbl}>Due Date</div><div style={val}>{order.dueDate ? fD(order.dueDate) : "—"}</div></div>
              <div><div style={lbl}>Payment Mode</div><div style={val}>{order.paymentMode || "—"}</div></div>
              <div>
                <div style={lbl}>Status</div>
                <div style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  padding: "2px 9px", borderRadius: 999,
                  background: sc.bg, color: sc.color, fontSize: 11, fontWeight: 500,
                  WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
                }}>
                  <span style={{ width: 6, height: 6, borderRadius: "50%", background: sc.dot, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} />
                  {order.status?.charAt(0).toUpperCase() + order.status?.slice(1)}
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, marginBottom: 14 }}>
              <div><div style={lbl}>Total Items</div><div style={val}>{order.items?.length || 0}</div></div>
            </div>

            <hr style={divider} />

            {/* ── Item Table ── */}
            <div style={secLabel}>Item Details</div>
            <div className="item-table-wrap" style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", minWidth: 800, borderCollapse: "collapse", tableLayout: "fixed" }}>
                <colgroup>
                  <col style={{ width: 24 }} />
                  <col style={{ width: "16%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "8%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "8%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th style={th}>#</th>
                    <th style={th}>Item Name</th>
                    <th style={thR}>MRP</th>
                    <th style={th}>HSN</th>
                    <th style={th}>GST%</th>
                    <th style={thR}>Qty</th>
                    <th style={th}>Unit</th>
                    <th style={th}>Packing</th>
                    <th style={thR}>Rate (Incl.)</th>
                    <th style={thR}>Taxable</th>
                    <th style={thR}>CGST</th>
                    <th style={thR}>SGST</th>
                    <th style={thR}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {calcItems.map((it, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
                      <td style={td}>{i + 1}</td>
                      <td style={{ ...td, fontWeight: 500 }} title={it.name}>{it.name}</td>
                      <td style={tdR}>{fN(it.mrp)}</td>
                      <td style={{ ...td, fontFamily: "monospace", fontSize: 10.5 }}>{it.hsn || "N/A"}</td>
                      <td style={td}>{it.gstRate}%</td>
                      <td style={tdR}>{it.quantity}</td>
                      <td style={td}>{it.unit || "pcs"}</td>
                      <td style={{ ...td, fontSize: 10.5, color: "#64748b", whiteSpace: "normal", wordBreak: "break-word" }}>{it.packingDisplay}</td>
                      <td style={tdR}>{fN(it.rate)}</td>
                      <td style={tdR}>{fN(it.taxable, 3)}</td>
                      <td style={tdR}>{fN(it.cgst, 3)}</td>
                      <td style={tdR}>{fN(it.sgst, 3)}</td>
                      <td style={{ ...tdR, fontWeight: 600 }}>{fN(it.total, 2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <hr style={divider} />

            {/* ── HSN GST Summary ── */}
            <div style={secLabel}>Cumulative HSN-Wise GST Summary</div>
            <div className="hsn-table-wrap" style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", minWidth: 580, borderCollapse: "collapse", tableLayout: "fixed" }}>
                <colgroup>
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "14%" }} />
                  <col style={{ width: "14%" }} />
                  <col style={{ width: "10%" }} />
                  <col style={{ width: "16%" }} />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th style={th}>HSN</th>
                    <th style={thR}>Taxable Amt</th>
                    <th style={thR}>SGST</th>
                    <th style={thR}>CGST</th>
                    <th style={thR}>CESS</th>
                    <th style={thR}>Total Amt</th>
                    <th style={th}>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(hsnMap).map(([hsn, v]) => (
                    <tr key={hsn}>
                      <td style={{ ...td, fontFamily: "monospace", fontSize: 10.5 }}>{hsn}</td>
                      <td style={tdR}>{fN(v.taxable, 2)}</td>
                      <td style={tdR}>{fN(v.sgst, 3)}</td>
                      <td style={tdR}>{fN(v.cgst, 3)}</td>
                      <td style={tdR}>{fN(v.cess, 3)}</td>
                      <td style={{ ...tdR, fontWeight: 600 }}>{fN(v.total, 2)}</td>
                      <td style={{ ...td, fontSize: 10, color: "#94a3b8", fontStyle: "italic" }}>All HSN {hsn} cumulative</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── Totals ── */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <div style={{ minWidth: 290 }}>
                <TotalRow label="Items Subtotal" value={fC(grandTotal, 2)} />
                <TotalRow label="CGST" value={fC(totalGST / 2, 2)} />
                <TotalRow label="SGST" value={fC(totalGST / 2, 2)} />

                {totalCess > 0 && <TotalRow label="CESS" value={fC(totalCess, 2)} />}

                <TotalRow label="Total GST (Incl. in price)" value={fC(totalGST + totalCess, 2)} />

                {deliveryCharge > 0
                  ? <TotalRow label="Delivery Charge" value={fC(deliveryCharge, 2)} />
                  : <TotalRow label="Delivery Charge" value="Free" green mono={false} />
                }

                {handlingCharge > 0
                  ? <TotalRow label="Handling Charge" value={fC(handlingCharge, 2)} />
                  : <TotalRow label="Handling Charge" value="Free" green mono={false} />
                }

                {couponDiscount > 0 && (
                  <TotalRow label="Coupon Discount" note={order.couponCode || undefined} value={`− ${fC(couponDiscount, 2)}`} green />
                )}

                <TotalRow label="Grand Total" value={fC(effectiveTotal, 2)} highlight />

                <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 6, textAlign: "right", fontStyle: "italic" }}>
                  * Item prices are GST-inclusive · Delivery &amp; Handling added separately
                </div>
              </div>
            </div>

          </div>

          {/* ── Footer ── */}
          <div style={{
            padding: "12px 28px",
            borderTop: "0.5px solid #e2e8f0",
            display: "flex", justifyContent: "space-between", alignItems: "center",
            background: "#f8fafc", flexWrap: "wrap", gap: 8,
            WebkitPrintColorAdjust: "exact", printColorAdjust: "exact",
          }}>
            <span style={{ fontSize: 11, color: "#94a3b8" }}>
              Thank you for your business · {order.vendor?.name} © {new Date().getFullYear()}
            </span>
            {/* Only show print button if invoice number exists */}
            {invoiceNo ? (
              <button
                className="no-print"
                onClick={() => window.print()}
                style={{
                  padding: "6px 16px", border: "0.5px solid #cbd5e1",
                  borderRadius: 8, background: "transparent",
                  fontSize: 11, fontWeight: 500, color: "#0f172a", cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                Print Invoice
              </button>
            ) : (
              <span className="no-print" style={{
                padding: "6px 12px", borderRadius: 8,
                background: "#fff7ed", border: "0.5px solid #fed7aa",
                fontSize: 11, color: "#c2410c", fontWeight: 500,
              }}>
                ⏳ Confirm order to generate invoice
              </span>
            )}
          </div>

        </div>
      </div>
    </>
  );
}